import { observer } from "mobx-react-lite"
import { useCallback, useRef, useState } from "react"
import { thumbUrl } from "../lib/api.js"
import { useStore } from "../stores/StoreProvider.js"

interface MasonryItemProps {
  id: string
  index: number
  onOpen: (index: number) => void
}

const MasonryItem = observer(function MasonryItem({ id, index, onOpen }: MasonryItemProps) {
  const [loaded, setLoaded] = useState(false)
  const loadStart = useRef(performance.now())
  const handleLoad = useCallback(() => setLoaded(true), [])
  const wasCached = loaded && performance.now() - loadStart.current < 50

  return (
    <div className={`gallery-masonry-item${!loaded ? " skeleton" : ""}`} onClick={() => onOpen(index)}>
      <img
        src={thumbUrl(id, 600, 600)}
        alt=""
        loading="lazy"
        className={loaded && !wasCached ? "img-fade-in" : ""}
        style={loaded ? undefined : { opacity: 0, minHeight: 120 }}
        onLoad={handleLoad}
      />
    </div>
  )
})

interface GalleryMasonryProps {
  mediaIds: string[]
}

export const GalleryMasonry = observer(function GalleryMasonry({ mediaIds }: GalleryMasonryProps) {
  const { viewerStore } = useStore()

  const handleOpen = (index: number) => {
    viewerStore.open(mediaIds, index)
  }

  return (
    <div className="gallery-masonry">
      {mediaIds.map((id, i) => (
        <MasonryItem key={id} id={id} index={i} onOpen={handleOpen} />
      ))}
    </div>
  )
})
